module.exports = __webpack_public_path__ + "img/INI.eb9f5824.png";